// extracted by mini-css-extract-plugin
module.exports = {"socialIconLink":"SocialIconLink-module--socialIconLink--thsxB"};